import { Dispatch } from "redux";
import {
  setAttendees,
  setLoading,
} from "../../store/slices/shiftHandOverSlice";
import { Attendee } from "../../store/slices/shiftHandOverSlice";

interface FetchAttendeesProps {
  setIsLoading: (isLoading: boolean) => void;
  setApiError: (error: string | null) => void;
  dispatch: Dispatch;
  fieldUsers?: any[];
  coeUsers?: any[];
}

const mapUserToAttendee = (user: any): Attendee => {
  const displayName =
    user.First_Name && user.Last_Name
      ? `${user.First_Name} ${user.Last_Name}`.trim()
      : user.Name && user.Name.trim()
      ? user.Name.trim()
      : user.UserEmail?.split("@")[0] ?? "";

  return {
    id: user.UserEmail ?? "",
    displayName,
    userPrincipalName: user.UserEmail ?? "",
  };
};

/**
 * Builds the attendees list from appData FieldUsers and COEUsers.
 * COEUsers take priority: if a user exists in both lists (matched by UserEmail),
 * the FieldUsers entry is omitted.
 * @param props Object containing required parameters
 */
export const fetchAttendees = async ({
  setIsLoading,
  setApiError,
  dispatch,
  fieldUsers = [],
  coeUsers = [],
}: FetchAttendeesProps): Promise<void> => {
  setIsLoading(true);
  setApiError(null);
  dispatch(setLoading(true));

  try {
    const coeEmailSet = new Set(
      (coeUsers).map((u: any) => (u.UserEmail ?? "").toLowerCase()).filter(Boolean)
    );

    const filteredFieldUsers = fieldUsers.filter(
      (u: any) => !coeEmailSet.has((u.UserEmail ?? "").toLowerCase())
    );

    const attendees: Attendee[] = [
      ...coeUsers.map(mapUserToAttendee),
      ...filteredFieldUsers.map(mapUserToAttendee),
    ].filter((a) => a.id);

    console.log(`Built ${attendees.length} attendees from appData`);
    dispatch(setAttendees(attendees));
  } finally {
    setIsLoading(false);
    dispatch(setLoading(false));
  }
};
